// import type { Container } from 'inversify';
// import nodeEnv from './env/contributions/module';
// import nodeWindow from './window/contributions/modules';
// import nodeCanvas from './canvas/contributions/node/modules';

// // 直接绑定node环境
// export function nodeLoader(container: Container) {
//   container.load(nodeEnv);
//   container.load(nodeWindow);
//   container.load(nodeCanvas);
// }
